import { combineEpics, ofType } from 'redux-observable';
import { pluck, switchMap } from 'rxjs/operators';

import { Epic } from 'src/config/rootEpic';
import { INITIAL_DATA_FETCH_READY } from 'src/shared/actions/sharedActions';

import {
    fetchProgramsProgressFail,
    fetchProgramsProgressSuccess,
    PROGRAM_WEEK_FINISHED,
    updateProgramWeekFail,
    updateProgramWeekSuccess,
    UPDATE_PROGRAM_WEEK_REQUESTED,
} from '../actions/programsActions';
import { UserProgramWeek } from '../models/programs';
import { ProgramsService } from '../services/ProgramsService';

export function programsEpicFactory(programsService: ProgramsService): Epic {
    const fetchProgramsProgressEpic: Epic = (action$: any) =>
        action$.pipe(
            ofType(INITIAL_DATA_FETCH_READY, 'who5/addNewSurvey', PROGRAM_WEEK_FINISHED),
            switchMap(
                () =>
                    programsService
                        .fetchProgramsProgress()
                        .then(fetchProgramsProgressSuccess)
                        .catch(fetchProgramsProgressFail), // TODO: Inform user about error with toasts
            ),
        );

    const updateProgramWeekEpic: Epic = action$ =>
        action$.pipe(
            ofType(UPDATE_PROGRAM_WEEK_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: UserProgramWeek) =>
                    programsService
                        .updateProgramWeek(data)
                        .then(updateProgramWeekSuccess)
                        .catch(updateProgramWeekFail), // TODO: Inform user about error with toasts
            ),
        );

    return combineEpics(fetchProgramsProgressEpic, updateProgramWeekEpic);
}
